// extracted by mini-css-extract-plugin
export default {"list":"_0HLfCpN-TOQppZZPif2XEQ=="};